import Image from "next/image";
import { useState, useRef, useEffect, cloneElement, useMemo } from "react";
import { bodyStore } from "@/store/bodyStore";
import bodyImage from "@public/body.png";
import styles from "./Body.module.scss";
import React from "react";

/**
 * ボディー コンポーネント
 * @returns {JSX.Element} ボディー コンポーネント
 */
export function Body() {
	const { body } = bodyStore();
	const [Hair, BackHair, Eyebrows, Eyeline, Eyes, Mouth] = body.map(
		(part) => part.partComponent,
	);
	const [
		hairStyle,
		backHairStyle,
		eyeBrowsStyle,
		eyelineStyle,
		eyesStyle,
		mouthStyle,
	] = body.map((part) => part.partStyle);
	const [baseImage, setBaseImage] = useState<{
		width: number;
		height: number;
	}>({
		width: 0,
		height: 0,
	});

	const bodyImageRef = useRef<HTMLImageElement | null>(null);

	useEffect(() => {
		const updateBaseImage = () => {
			if (bodyImageRef.current) {
				const baseImageData = {
					width: bodyImageRef.current.offsetWidth,
					height: bodyImageRef.current.offsetHeight,
				};

				setBaseImage(baseImageData);
			}
		};
		// 初期レンダリング時に幅を設定
		updateBaseImage();
		// ウィンドウサイズが変更されたときに幅を更新
		window.addEventListener("resize", updateBaseImage);
		// クリーンアップ
		return () => {
			window.removeEventListener("resize", updateBaseImage);
		};
	}, []);

	return (
		<div className={styles.bodyContainer}>
			<Image
				ref={bodyImageRef}
				src={bodyImage}
				alt="素体"
				className={styles.bodyImage}
				style={{ width: "auto", height: "100%" }}
			/>
			<div
				className={styles.displayHairPart}
				style={{
					width: `calc(${baseImage.width}px * 0.92)`,
					height: "auto",
				}}
			>
				{Hair && <Hair {...hairStyle} />}
			</div>
			<div
				className={styles.displayBackHairPart}
				style={{
					width: `calc(${baseImage.width}px * 1.8)`,
					height: "auto",
				}}
			>
				{BackHair && <BackHair {...backHairStyle} />}
			</div>
			<div
				className={styles.displayEyebrowsPart}
				style={{
					width: `calc(${baseImage.width}px * 0.8)`,
					height: "auto",
				}}
			>
				{Eyebrows && <Eyebrows {...eyeBrowsStyle} />}
			</div>
			{/* <div className={styles.eyesErea}></div> */}
			<div
				className={styles.displayEyelinePart}
				style={{
					width: `calc(${baseImage.width}px * 0.8)`,
					height: "auto",
					zIndex: "3",
				}}
			>
				{Eyeline && <Eyeline {...eyelineStyle} showProcess={1} />}
			</div>
			<div
				className={styles.displayEyespart}
				style={{
					width: `calc(${baseImage.width}px * 0.7)`,
					height: "auto",
					zIndex: "2",
				}}
			>
				{Eyes && <Eyes {...eyesStyle} />}
			</div>
			<div
				className={styles.displayEyelinePart}
				style={{
					width: `calc(${baseImage.width}px * 0.8)`,
					height: "auto",
					zIndex: "1",
				}}
			>
				{Eyeline && <Eyeline {...eyelineStyle} showProcess={2} />}
			</div>
			<div
				className={styles.displayMouthPart}
				style={{
					width: `calc(${baseImage.width}px * 0.2)`,
					height: "auto",
				}}
			>
				{Mouth && <Mouth {...mouthStyle} />}
			</div>
		</div>
	);
}
